// https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=286%3A17768

import { useCallback } from 'react';
import { defineMessages, FormattedMessage } from '@alltrails/shared/react-intl';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import Checkbox from '@alltrails/shared/denali/components/Checkbox';
import UploadProgressBar from '../UploadProgressBar';
import { formatBytes } from '../../../utils/upload_helpers';
import successUpload from '../../../../assets/images/icons/share/filled@2x.png';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';

const TRACK_FILE_UPLOAD_STRINGS = defineMessages({
  REMOVE_FILE: { defaultMessage: 'Remove file' },
  SMOOTH_FILE: { defaultMessage: 'Smooth file' }
});

const TrackFileUpload = ({ file, removeFile, handleCheckboxChange, smoothFile, progress, uploaded, uploading }) => {
  const {
    formattedDefaultMessages: { FILE_SIZE, REMOVE_FILE, SMOOTH_FILE }
  } = useFormatMessage(TRACK_FILE_UPLOAD_STRINGS);
  const memoRemoveFile = useCallback(() => {
    removeFile(file);
  }, [file]);

  return (
    <div className={styles.container}>
      <div className={styles.checkboxAndFiletype}>
        {uploaded && <img src={successUpload} alt="success" className={styles.successUpload} />}
        <div className={styles.fileType}>{file.type || 'GPX'}</div>
      </div>
      <div className={styles.fileInformation}>
        <div className={styles.metaData}>
          <div className={styles.fileName}>{file.name}</div>
          <UploadProgressBar progress={progress} />
          <div className={styles.fileSize}>
            <FormattedMessage defaultMessage="File size:" /> {formatBytes(file.size)}
          </div>
        </div>
        <div className={styles.controls}>
          <button onClick={memoRemoveFile} type="button" className={styles.removeButton}>
            {REMOVE_FILE}
          </button>
          <div>
            <Checkbox
              labelElement={SMOOTH_FILE}
              id="smooth"
              testId="checkbox-smooth-file"
              selected={smoothFile}
              disabled={uploaded || uploading}
              onChange={handleCheckboxChange}
              className={styles.labelClassName}
              size="sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

TrackFileUpload.propTypes = {
  file: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number
  }).isRequired,
  removeFile: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  smoothFile: PropTypes.bool,
  progress: PropTypes.number,
  uploaded: PropTypes.bool,
  uploading: PropTypes.bool
};

TrackFileUpload.defaultProps = {
  removeFile: () => {},
  handleCheckboxChange: () => {},
  smoothFile: true,
  progress: 0,
  uploaded: false,
  uploading: false
};

export default TrackFileUpload;
